import { privateClient } from "@/api/privateClient";
import { SUPER_ADMIN_ENDPOINTS } from "../../../endpoint";
import type { SocialLink } from "../types";

export const listSocialLinks = async (): Promise<SocialLink[]> => {
  const { data } = await privateClient.get(SUPER_ADMIN_ENDPOINTS.CMS.SOCIAL_LINKS.LIST);
  return data.links ?? data;
};

export const createSocialLink = async (payload: Omit<SocialLink, "id">): Promise<SocialLink> => {
  const { data } = await privateClient.post(SUPER_ADMIN_ENDPOINTS.CMS.SOCIAL_LINKS.CREATE, payload);
  return data.link ?? data;
};

export const updateSocialLink = async (id: number, payload: Omit<SocialLink, "id">): Promise<SocialLink> => {
  const { data } = await privateClient.put(SUPER_ADMIN_ENDPOINTS.CMS.SOCIAL_LINKS.UPDATE(id), payload);
  return data.link ?? data;
};

export const deleteSocialLink = async (id: number): Promise<void> => {
  await privateClient.delete(SUPER_ADMIN_ENDPOINTS.CMS.SOCIAL_LINKS.DELETE(id));
};
